module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Sort Items",
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialise
    }
  }, [_c('draggable', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": {
        animation: 350,
        group: 'items',
        xxxhandle: '.draggable-handle'
      }
    },
    on: {
      "end": _vm.afterDrag
    },
    model: {
      value: (_vm.localItems),
      callback: function($$v) {
        _vm.localItems = $$v
      },
      expression: "localItems"
    }
  }, _vm._l((_vm.localItems), function(item) {
    return _c('div', {
      key: item.meta.key,
      staticClass: "list-tile clickable hoverable",
      attrs: {
        "data-order": item.order
      },
      on: {
        "click": function($event) {
          return _vm.itemClicked(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-2px",
        "margin-right": "-15px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "draggable-handle",
            staticStyle: {
              "color": "#ddd"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.addItem
      }
    }, [_c('v-list-item-title', [_vm._v("Add New")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._t("default", [_vm._v("    \n                 " + _vm._s(item.name) + "\n            ")], null, item)], 2)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d90f7e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/SortDialog.vue
// module id = 2514
// module chunks = 1